import { SUPER_USER } from "../constants/key.const";
import { formatDate } from "../services/dateService";
import ConfirmationModal from "../component/ConfirmationModal";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import axios from "axios";
import { API, getAuthHeader } from "../constants/api.const";
import { useNavigate } from "react-router-dom";
import { deleteConsultation } from "../services/dataService";
import InfiniteScroll from "react-infinite-scroll-component";
import { useUnreviewedSummaries } from "../hooks/useUnreviewedSummaries";
import { useDeleteSummary } from "../hooks/useDeleteSummary";
import PersonIcon from "@mui/icons-material/Person";
import Loader from "./Loader";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function UnreviewedSummaries() {
  const [showModal, setShowModal] = useState(false);
  // const [selectedId, setSelectedId] = useState(null);
  const {
    data,
    isLoading: isPending,
    isError,
    error,
    hasNextPage,
    fetchNextPage,
  } = useUnreviewedSummaries();
  const { mutate: deleteMutation } = useDeleteSummary();
  const navigate = useNavigate();
  const summaries = data?.pages?.flatMap((page) => page?.results) || [];
  // const handleDeleteClick = (appointmentId, event) => {
  //   event.stopPropagation();
  //   setSelectedId(appointmentId);
  //   setShowModal(true);
  // };
  const review = (recordingId) => {
    navigate("/home/walkthrough/review-note", {
      state: { recordingId },
    });
  };

  const handleDeleteAppointment = async (appointmentId) => {
    deleteMutation(appointmentId);
  };

  return (
    <div className="hidden md:block bg-white rounded-xl px-3 md:px-7 md:w-[40%] lg:w-[40%] h-full overflow-x-auto">
      <div className="sticky top-0 pt-3 bg-white z-10">
        <h3 className="text-black text-xl font-bold border-b-2 border-[rgba(188,188,188,0.581)] pb-2.5">
          For review
        </h3>
      </div>
      <div
        className="overflow-y-auto h-[85%] flex flex-col gap-2"
        id="scrollableDiv"
      >
        {isPending && summaries.length == 0 ? (
          <Loader />
        ) : !!!summaries.length ? (
          <div className="text-center text-custom-green mt-4">
            There are no summaries
          </div>
        ) : (
          <InfiniteScroll
            dataLength={summaries.length}
            next={fetchNextPage}
            hasMore={hasNextPage ?? false}
            loader={
              <p className="text-center text-custom-green font-medium py-4 gap-2">
                Loading...
              </p>
            }
            scrollableTarget="scrollableDiv"
          >
            {data?.pages
              ?.flatMap((page) => page.results)
              ?.map((item, index) => {
                console.log(item);
                return (
                  <div
                    key={index}
                    className="rounded border border-[#f1f1f1] p-2 flex justify-between items-center cursor-pointer mb-2"
                    onClick={() => review(item.recording_id)}
                  >
                    <div className="flex items-center">
                      <div className="font-bold text-[#161616]">
                        <div className="p-2 rounded-xl bg-[#3666e917] text-darkblue mr-8">
                          <PersonIcon
                            className="text-custom-green fill-custom-green"
                            fontSize="large"
                          />
                        </div>
                      </div>
                      <div className="text-lg text-[#a9a9a9] font-bold">
                        {formatDate(item.created_at)}
                      </div>
                      {/* <div className="text-xs text-[#a9a9a9] font-medium">
                        {formatDate(item.appointment.appointment_end_time, {
                          timeStyle: "short",
                          hourCycle: "h23",
                        })}
                      </div> */}
                    </div>
                    {item.is_processed === false && (
                      <AccessTimeIcon className="text-custom-green !h-8 !w-8" />
                    )}
                  </div>
                );
              })}
          </InfiniteScroll>
        )}
      </div>
      {/* <ConfirmationModal
        text="Ste prepričani, da želite izbrisati to naročilo?"
        show={showModal}
        title="Potrdite brisanje"
        handleClose={async (confirmed) => {
          setShowModal(false);
          if (confirmed && selectedId) {
            handleDeleteAppointment(selectedId);
          }
        }}
      /> */}
    </div>
  );
}
